export default __webpack_public_path__ + "static/Tapetsering4-1705e9dde85e6c25eca9a613ff89ba19.jpg";